// extracted by mini-css-extract-plugin
export default {"container":"_1Sq7Q___VideoPlayer-module__container","story":"_1ftB2___VideoPlayer-module__story"};